import React from "react";
import cloudStore from "../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useParams } from "react-router-dom";
import ImageUploader from "react-images-upload";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { rootUrl } from "../Api";

export default function MerchantLogo() {
  const params = useParams();
  const spMerchantId = Number.parseInt(params.spMerchantId);
  const taMerchantId = Number.parseInt(params.taMerchantId);
  const spMerchant = cloudStore.merchant?.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);
  const taMerchant = cloudStore.merchant?.ta_merchants.find((taMerchant) => taMerchant.id === taMerchantId);
  let [loading, setLoading] = React.useState(false);

  if (loading) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const save = (picture) => {
    setLoading(true);
    const merchantId = spMerchantId ? spMerchantId : taMerchantId;
    const nameMerchant = spMerchantId ? "spMerchantId" : "taMerchantId";
    let bodyFormData = new FormData();
    bodyFormData.set(nameMerchant, merchantId);
    bodyFormData.set("image", picture);
    axios
      .post(rootUrl + `/nova/logo`, bodyFormData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (spMerchantId) {
          spMerchant.image = res.data.image_url;
        } else {
          taMerchant.image = res.data.image_url;
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const onDrop = (pictures) => {
    save(pictures[0]);
  };

  let url = null;
  if (spMerchantId) {
    if (spMerchant && spMerchant.image != null) {
      url = `https://mynober-api-public.s3.eu-central-1.amazonaws.com/${spMerchant.image}`;
    }
  } else {
    if (taMerchant && taMerchant.image != null) {
      url = `https://mynober-api-public.s3.eu-central-1.amazonaws.com/${taMerchant.image}`;
    }
  }

  return (
    <div style={{ width: "50%" }}>
      <Typography variant="h4">{spMerchantId ? "Logo Inhouse" : "Logo Takeaway & Delivery"}</Typography>
      {url && <img width={300} src={url} alt={"logo"} />}
      <ImageUploader
        withIcon
        buttonText="Choose image"
        onChange={onDrop}
        imgExtension={["png"]}
        maxFileSize={5242880 * 4}
        label={"Max file size 20mb. Accepted is png"}
        withPreview
        singleImage
      />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
